/* =========================

  which is name

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

// Retina用imgタグ
import ImageRetina from "../../../Components/Part/ImageRetina";

/* -------------------------

  component

---------------------------- */
function Finish( props ) {

  return (
    <Styled>
      <div className="p-finish">
        <section className="p-finish__section--answer p-finish__section">
          <div className="p-finish__section__inner l-inner--1100">

            {/* コンテンツ */}
            <div className="p-finish__section__conts p-keyvisual__layer_02">
              {/* タイトル */}
              <div className="p-finish__block--title p-finish__block">
                <div className="p-finish__box--h2 p-finish__box c-font_f--km">
                  <h2 className="title"><span className="font-color">診断結果</span>が出ました！<br /><span className="font-size">あなたにぴったりの商品を<br className="sp_only" />ご案内します。</span></h2>
                </div>
              </div>
              {/* タイトル */}

              {/* ボタン */}
              <div className="p-finish__block--btn p-finish__block">
                <div className="p-finish__box--btn p-finish__box">
                  {props.children}
                </div>
              </div>
              {/* ボタン */}
            </div>
            {/* コンテンツ */}

            {/* 背景 */}
            <div className="p-finish__section__bg p-keyvisual__layer_01">
              <div className="p-finish__block--bg p-finish__block">
                <div className="p-finish__box--bg_01 p-finish__box">
                  <div className="img_territory_01 img_territory">
                    <ImageRetina
                      type={"png"}
                      src_pc_1x={"/assets/img/top/p-finish/finish-img02.png"}
                      src_pc_2x={"/assets/img/top/p-finish/finish-img02@2x.png"}
                      src_sp_1x={"/assets/img/top/p-finish/sp/finish-img02.png"}
                      src_sp_2x={"/assets/img/top/p-finish/sp/finish-img02@2x.png"}
                      alt={""}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 背景 */}
          </div>
        </section>
      </div>
    </Styled>
  );
}

export default Finish;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  .p-finish {
    color: #451700;
    margin: 40px 0 40px 0;
    .p-finish__section--answer {
      .p-finish__section__inner {
        position: relative;
        padding: 90px 50px 67px 50px;
        background-color: #ffffff;
        border-radius: 20px;
        &::before {
          position: absolute;
          right: 33px;
          bottom: 22px;
          content: "";
          display: block;
          width: 140px;
          height: 102px;
          background-image: url(${process.env.PUBLIC_URL}/assets/img/top/leaf-img01.png);
          background-size: 100% auto;
        }
        .p-keyvisual__layer_02 {
          z-index: 2;
        }
        .p-keyvisual__layer_01 {
          z-index: 1;
        }
        .p-finish__section__conts {
          position: relative;
          .p-finish__block--title {
            .p-finish__box--h2 {
              text-align: center;
              .title {
                display: inline-block;
                font-size: 3.6rem;
                font-weight: 500;
                line-height: 2.3;
                .font-color {
                  position: relative;
                  display: inline-block;
                  color: #ed7200;
                  &::before {
                    position: absolute;
                    top: 50%;
                    left: -50px;
                    transform: translateY(-50%);
                    content: "";
                    display: block;
                    width: 33px;
                    height: 34px;
                    background-image: url(${process.env.PUBLIC_URL}/assets/img/top/p-finish/finish-img01.png);
                    background-size: 100% auto;
                  }
                }
              }
            }
          }
          .p-finish__block--btn {
            margin-top: 45px;
            .p-finish__box--btn {
              display: flex;
              justify-content: center;
            }
          }
        }
        .p-finish__section__bg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          .p-finish__block--bg {
            height: 100%;
            .p-finish__box--bg_01 {
              position: absolute;
              width: 200px;
              height: 431px;
              top: 37px;
              left: 14px;
            }
          }
        }
      }
    }
  }

  
  @media ${break_point_sp} {
    .p-finish {
      margin: 5% 3%;
      .p-finish__section--answer {
        .p-finish__section__inner {
          padding: 10% 5% 0 5%;
          &::before {
            content: none;
          }
          .p-finish__section__conts {
            .p-finish__block--title {
              .p-finish__box--h2 {
                .title {
                  font-size: calc(56 / 750 * 100vw);
                  line-height: normal;
                  &::before {
                      content: "";
                      display: block;
                      width: 33px;
                      height: 34px;
                      margin: auto auto 15px auto;
                      background-image: url(${process.env.PUBLIC_URL}/assets/img/top/p-finish/finish-img01.png);
                      background-size: 100% auto;
                    }
                  .font-color {
                    &::before {
                      content: none;
                    }
                  }
                  .font-size {
                    display: inline-block;
                    margin-top: 1em;
                    font-size: calc(48 / 750 * 100vw);
                  }
                }
              }
            }
            .p-finish__block--btn {
              .p-finish__box--btn {
                display: block;
              }
            }
          }
          .p-finish__section__bg {
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin-top: 35px;
            .p-finish__block--bg {
              .p-finish__box--bg_01 {
                position: relative;
                width: 80%;
                height: auto;
                top: auto;
                left: auto;
                margin: auto;
              }
            }
          }
        }
      }
    }
  }
`;
